import { render, staticRenderFns } from "./viewprofile.vue?vue&type=template&id=4527d6cc&scoped=true&"
import script from "./viewprofile.vue?vue&type=script&lang=js&"
export * from "./viewprofile.vue?vue&type=script&lang=js&"
import style0 from "./viewprofile.vue?vue&type=style&index=0&id=4527d6cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527d6cc",
  null
  
)

export default component.exports